var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[(_vm.showNavigation)?_c('div',[_c('app-navigation')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }